const Logo = ({ size }) => {
    return (
        <a className="logo" href="/">
            <img className={size} alt="Pages on Pages" src="/Pages-on-Pages-modified.png" />
         </a>
    )
}

export default Logo;